export default {"src":"/_next/static/media/englishmuffin.2322d346.svg","height":681,"width":681,"blurWidth":0,"blurHeight":0};